import { ScrollDrawer } from "@portal/BaseComponents/Drawer/ScrollDrawer";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { FormHeader } from "@portal/BaseComponents/UI/FormArea/FormHeader";
import { Icon } from "@portal/lib/icons/icons";
import { Fragment } from "react";

import useOpen from "@portal/hooks/useOpen";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { useCreditMemoDetailsQuery } from "@portal/queries/credit-notes-query";
import { useParams } from "react-router-dom";
import { CreditDetailsComp } from "./Details/CreditDetails";
import { CreditDetailsViewProps } from "./type";
import { DRAWER_ZINDEX } from "@portal/BaseComponents/Drawer/predicate";

const CreditIcon = <Icon icon={["far", "coin"]} color="var(--lime-6)" />;
const t = {
  title: "Credit Details",
};
function CreditDetailsView(props: CreditDetailsViewProps) {
  const {
    id,
    open,
    header,
    headerTitle = t.title,
    actionButton,
    onClose,
  } = props;

  const { open: commentOpen } = useOpen({ open: false });

  const { data, isLoading } = useCreditMemoDetailsQuery(id);

  const navigate = usePageNavigate();
  const { customer_id } = useParams<AppPageParams>();

  function handleClose() {
    if (!customer_id) return;
    onClose?.();
    navigate({
      appPage: "CREDIT_DETAILS",
      pathParams: {
        customer_id,
      },
    });
  }
  const HeaderTitle = (
    <Flex align="center" justify="center" space="16">
      {CreditIcon}
      <TypographyText style={{ fontWeight: "var(--fs-regular)" }} fs="16">
        {`${headerTitle} - #${data ? data.reference : ""}`}
      </TypographyText>
    </Flex>
  );
  const ActionArea = (
    <Flex>
      {actionButton?.map((action) => (
        <Fragment key={action.id}>{action.component}</Fragment>
      ))}
    </Flex>
  );
  const Header = header ? (
    header
  ) : (
    <FormHeader
      mode="drawer"
      onClose={handleClose}
      title={HeaderTitle}
      extra={ActionArea}
    />
  );

  // const Footer = footer ? (
  //   footer
  // ) : (
  //   <Comment type='DRAWER' activity="credit-memos" id={id} />
  // );

  function getFooterStyle() {
    return {
      padding: commentOpen ? 0 : "var(--space-12) var(--space-24)",
      backgroundColor: "var(--gray-2)",
    };
  }

  const footerStyle = getFooterStyle();

  return (
    <ScrollDrawer
      title={Header}
      open={open}
      width={640}
      mask={true}
      maskClosable
      onClose={handleClose}
      getContainer={false}
      styles={{
        wrapper: {
          background: "var(--gray-1)",
          boxShadow: "var(--shadow-4)",
          height: "var(--drawer-height)",
        },
         header: {
          padding: 0,
        },
        footer: footerStyle,
        mask: {
          position: "fixed",
          inset: 0,
        },
      }}
      push={false}
      destroyOnClose
      zIndex={DRAWER_ZINDEX}
    >
     <CreditDetailsComp data={data} loading={isLoading} />
    </ScrollDrawer>
  );
}

export { CreditDetailsView };
